import React from "react";

const GlobalContext = React.createContext({
    roomId: null,
});

export default GlobalContext;